import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCookies from 'vue-cookies'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import steem from 'steem'
// import hive from 'steem'
import ipfsClient from 'ipfs-http-client'

import {getstr} from "./utils/getstr"
import {imgAdd} from "./utils/imgAdd"
import {imgEdit} from "./utils/imgEdit"
import {initDatabase} from "./utils/initDatabase"
import {getAllPosts} from "./utils/getAllPosts"
import {getAllChapters} from "./utils/getAllChapters"
import {postToSteem} from "./utils/postToSteem"
import {postToSteemPro} from "./utils/postToSteemPro"
// import {postToHive} from "./utils/postToHive"
import {saveOneToDb} from "./utils/saveOneToDb"
import {getPostsFromSteem} from "./utils/getPostsFromSteem"


Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.use(mavonEditor)


//设置steem节点,挂载到全局
steem.api.setOptions({ url: 'https://api.steemitdev.com' })
// steem.api.setOptions({ url: 'https://cn.steems.top' })
Vue.prototype.steem= steem

//设置hive节点, 挂载到全局
// Vue.prototype.hive= hive

//设置ipfs节点, ,挂载到全局
const ipfs = ipfsClient({ host: 'steemjiang.com', port: '9001', protocol: 'https' })
Vue.prototype.ipfs = ipfs

//ipfs访问地址
const ipfsAddr = "https://steemjiang.com:8081/ipfs/"
Vue.prototype.ipfsAddr = ipfsAddr

Vue.prototype.getstr = getstr
Vue.prototype.imgAdd = imgAdd
Vue.prototype.imgEdit = imgEdit
Vue.prototype.initDatabase = initDatabase
Vue.prototype.getAllPosts = getAllPosts
Vue.prototype.getAllChapters = getAllChapters
Vue.prototype.postToSteem = postToSteem
Vue.prototype.postToSteemPro = postToSteemPro
// Vue.prototype.postToHive = postToHive
Vue.prototype.saveOneToDb = saveOneToDb
Vue.prototype.getPostsFromSteem = getPostsFromSteem


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
